// File: components/constants.ts
export const COMPONENT_TYPES = {
  TEXT: "text",
  WIDGET: "widgets",
};
